import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { country, lang } from '@sc/data-access-models';
import { languageFlagMapping } from './utils';

@Component({
  selector: 'sc-flag',
  styleUrls: ['./flag.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [],
  template: ` <span [class]="flagClass()"></span> `,
})
export class FlagComponent implements OnInit {
  @Input() lang?: lang;
  @Input() country?: country;
  @Input() squared?: boolean;

  ngOnInit(): void {
    if (!this.lang && !this.country) {
      throw new Error(
        'sc-flag should have at least one of the following inputs set : "lang", "country"'
      );
    }
  }

  langFlagClass() {
    if (this.lang) {
      return languageFlagMapping[this.lang];
    } else if (this.country) {
      return `flag-icon-${this.country}`;
    }

    return '';
  }

  flagClass() {
    // Generate the span css class in order to show the flag
    return `flag-icon ${this.langFlagClass()} ${
      this.squared ? 'flag-icon-squared' : ''
    }`;
  }
}
